import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit';
import {RootState} from './store';
import {BackButtonAction} from '../core/utils/string.util';
import {isLoggedInEmployee, isLoggedInUser} from '../core/utils/routing.util';
import {stat} from 'fs';

interface globalState {
  isUserLoggedIn: boolean;
  isEmployeeLoggedIn: boolean;
  isElite: boolean;
  paymentMode: string;
  appBarTitle: string | null;
  isBackNavEnabled: boolean;
  isActivityRunning: boolean;
  loaderRunning: boolean;
  appBarBackNavAction: BackButtonAction | undefined;
  paymentCheckButton: boolean;
  enableMobileInput: boolean;
}
const initialState: globalState = {
  appBarTitle: null,
  isBackNavEnabled: false,
  isElite: false,
  paymentMode: '',
  isActivityRunning: false,
  loaderRunning: false,
  appBarBackNavAction: undefined,
  isUserLoggedIn: isLoggedInUser(),
  paymentCheckButton: false,
  isEmployeeLoggedIn: isLoggedInEmployee(),
  enableMobileInput: false,
};
export const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setAppBarTitle: (
      state: {appBarTitle: any},
      action: PayloadAction<string>,
    ) => {
      state.appBarTitle = action.payload;
    },
    setBackNavEnabled: (
      state: {isBackNavEnabled: any},
      action: PayloadAction<boolean>,
    ) => {
      state.isBackNavEnabled = action.payload;
    },
    setActivityRunning: (
      state: {isActivityRunning: any},
      action: PayloadAction<boolean>,
    ) => {
      state.isActivityRunning = action.payload;
    },
    setLoaderRunning: (
      state: {loaderRunning: any},
      action: PayloadAction<boolean>,
    ) => {
      state.loaderRunning = action.payload;
    },
    setEnableMobileInput: (
      state: {enableMobileInput: any},
      action: PayloadAction<boolean>,
    ) => {
      state.enableMobileInput = action.payload;
    },
    setPaymentEnableButton: (
      state: {paymentCheckButton: any},
      action: PayloadAction<boolean>,
    ) => {
      state.paymentCheckButton = action.payload;
    },
    setBackNavAction: (
      state: {appBarBackNavAction: any},
      action: PayloadAction<BackButtonAction | undefined>,
    ) => {
      console.log('in global slice', action.payload);
      state.appBarBackNavAction = action.payload;
    },
    setUserLoggedIn: (state, action: PayloadAction<boolean | undefined>) => {
      state.isUserLoggedIn = action.payload || isLoggedInUser();
    },
    setEmployeeLoggedIn: (
      state,
      action: PayloadAction<boolean | undefined>,
    ) => {
      state.isEmployeeLoggedIn = action.payload || isLoggedInEmployee();
    },
    setIsUserElite: (state, action: PayloadAction<boolean>) => {
      state.isElite = action.payload;
    },
    setPaymentMode: (
      state: {paymentMode: string},
      action: PayloadAction<string>,
    ) => {
      state.paymentMode = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addMatcher(
      action => {
        const _action = action.type as string;

        return (
          _action.endsWith('/loading') ||
          _action.endsWith('/pending') ||
          _action.endsWith('/rejected') ||
          _action.endsWith('/fulfilled')
        );
      },
      (state, action) => {
        state.isActivityRunning = !state.isActivityRunning;
      },
    );
  },
});

export const {
  setAppBarTitle,
  setBackNavEnabled,
  setBackNavAction,
  setUserLoggedIn,
  setEmployeeLoggedIn,
  setIsUserElite,
  setActivityRunning,
  setLoaderRunning,
  setPaymentEnableButton,
  setPaymentMode,
  setEnableMobileInput,
} = globalSlice.actions;

export const appBarTitle = (state: RootState): string | null =>
  state.globalReducer.appBarTitle;

export const paymentModeData = (state: RootState): string =>
  state.globalReducer.paymentMode;
export const isBackNavEnabled = (state: RootState): boolean =>
  state.globalReducer.isBackNavEnabled;
export const isActivityRunning = (state: RootState): boolean =>
  state.globalReducer.isActivityRunning;
export const appBarBackNavAction = (
  state: RootState,
): BackButtonAction | undefined => state.globalReducer.appBarBackNavAction;
export const isUserLoggedIn = (state: RootState): boolean =>
  state.globalReducer.isUserLoggedIn;
export const isUserElite = (state: RootState): boolean =>
  state.globalReducer.isElite;
export const loaderRunning = (state: RootState): boolean =>
  state.globalReducer.loaderRunning;

export const isEmployeeLoggedIn = (state: RootState): boolean =>
  state.globalReducer.isEmployeeLoggedIn;
export const enableMobileInput = (state: RootState): boolean =>
  state.globalReducer.enableMobileInput;
// export const setPaymentMode = (state: RootState): string =>
//   state.globalReducer.paymentMode;
export const paymentCheckButton = (state: RootState): boolean =>
  state.globalReducer.paymentCheckButton;
export default globalSlice.reducer;
